const serverHost = process.env.REACT_APP_SERVER_HOSTNAME;

export { serverHost };
